import toastr from "toastr";

const pageFavorite = {
    showToastMessage: function (message) {
        toastr.options = {
            closeButton: false,
            debug: false,
            newestOnTop: false,
            progressBar: false,
            positionClass: "toast-bottom-full-width",
            preventDuplicates: false,
            onclick: null,
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "5000",
            extendedTimeOut: "1000",
            showEasing: "swing",
            hideEasing: "linear",
            showMethod: "fadeIn",
            hideMethod: "fadeOut"
        };
        toastr.success(message);
    }
};

window.pageFavorite = pageFavorite;

$(document).ready(function (e) {
    if ($(".js-favorite-page").length === 0) {
        return;
    }

    // メモ更新のトースト表示
    const messageObject = $(".memo_flashMessage");
    if (messageObject.length !== 0) {
        const messageString = $(messageObject).data("flash_message");
        if (messageString !== "") {
            pageFavorite.showToastMessage(messageString);
        }
    }
});
